import { render } from "./NoProductFound.vue?vue&type=template&id=cf602b4e&scoped=true"
const script = {}

import "./NoProductFound.vue?vue&type=style&index=0&id=cf602b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf602b4e"]])

export default __exports__